// frontend/src/components/Suppliers/SupplierFilters.jsx
import React from 'react';
import { Search, X } from 'lucide-react';

const SupplierFilters = ({ filters, setFilters, categories }) => {
  const update = (key, val) => setFilters(prev => ({ ...prev, [key]: val }));

  const hasActive = filters.search || filters.status || filters.category_id || filters.is_preferred !== '';

  const reset = () => setFilters({ search: '', status: '', category_id: '', is_preferred: '' });

  // Grouper les catégories par group_name pour le select
  const grouped = categories.reduce((acc, cat) => {
    const g = cat.group_name || 'Other';
    if (!acc[g]) acc[g] = [];
    acc[g].push(cat);
    return acc;
  }, {});

  return (
    <div className="bg-gray-800/50 rounded-xl p-4 border border-gray-700">
      <div className="flex flex-col sm:flex-row gap-3">

        {/* Search */}
        <div className="relative flex-1">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search by name, email, city..."
            value={filters.search}
            onChange={e => update('search', e.target.value)}
            className="w-full bg-gray-900 border border-gray-700 rounded-lg pl-9 pr-4 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-emerald-500"
          />
        </div>

        {/* Status */}
        <select
          value={filters.status}
          onChange={e => update('status', e.target.value)}
          className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-emerald-500"
        >
          <option value="">All Statuses</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="pending">Pending</option>
        </select>

        {/* Category */}
        <select
          value={filters.category_id}
          onChange={e => update('category_id', e.target.value)}
          className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-emerald-500"
        >
          <option value="">All Categories</option>
          {Object.entries(grouped).map(([group, cats]) => (
            <optgroup key={group} label={group}>
              {cats.map(cat => (
                <option key={cat.id} value={cat.id}>{cat.name}</option>
              ))}
            </optgroup>
          ))}
        </select>

        {/* Preferred */}
        <select
          value={filters.is_preferred}
          onChange={e => update('is_preferred', e.target.value)}
          className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-emerald-500"
        >
          <option value="">All</option>
          <option value="true">Preferred Only</option>
        </select>

        {/* Reset */}
        {hasActive && (
          <button
            onClick={reset}
            className="flex items-center gap-1 px-3 py-2 text-sm text-gray-400 hover:text-white hover:bg-gray-700/50 rounded-lg transition-colors"
          >
            <X size={14} /> Clear
          </button>
        )}
      </div>
    </div>
  );
};

export default SupplierFilters;